import { Pipe, PipeTransform } from '@angular/core';
import {
  Quote,
  QUOTE_WORKFLOW_STATUSES,
  QuoteStatusHistory,
  QuoteWorkflowStatus,
} from '@lockton-apps/shared/interfaces';

import { findLast, includes, sortBy } from 'lodash';

export type QuoteDetails = Record<
  'proposal' | 'quote' | 'payment',
  Record<string, any>
>;

@Pipe({
  name: 'workflowStatusHistory',
  standalone: true,
})
export class WorkflowStatusHistoryPipe implements PipeTransform {
  transform(quote: Quote): QuoteDetails {
    return {
      proposal: {
        sentToClient: this.getTimestamp(
          quote,
          QUOTE_WORKFLOW_STATUSES.ProposalSent
        ),
        lastUpdated: this.getTimestamp(quote, [
          QUOTE_WORKFLOW_STATUSES.ProposalInProgress,
          QUOTE_WORKFLOW_STATUSES.ProposalComplete,
        ]),
        submitted: this.getTimestamp(
          quote,
          QUOTE_WORKFLOW_STATUSES.ProposalComplete
        ),
        returned: this.getTimestamp(
          quote,
          QUOTE_WORKFLOW_STATUSES.ProposalReleased
        ),
      },
      quote: {
        requested: this.getTimestamp(
          quote,
          QUOTE_WORKFLOW_STATUSES.QuoteRequested
        ),
        ready: this.getTimestamp(quote, QUOTE_WORKFLOW_STATUSES.QuoteReady),
        sentToClient: this.getTimestamp(
          quote,
          QUOTE_WORKFLOW_STATUSES.QuoteSent
        ),
        clientAccepted: this.getTimestamp(
          quote,
          QUOTE_WORKFLOW_STATUSES.QuoteAccepted
        ),
      },
      payment: {
        invoiceSent: this.getTimestamp(
          quote,
          QUOTE_WORKFLOW_STATUSES.AwaitingPayment
        ),
        invoicePaid: this.getTimestamp(
          quote,
          QUOTE_WORKFLOW_STATUSES.PaymentReceived
        ),
        documentationSent: this.getTimestamp(
          quote,
          QUOTE_WORKFLOW_STATUSES.PolicyDocumentationSent
        ),
      },
    };
  }

  private getTimestamp(
    quote: Quote,
    statuses?: QuoteWorkflowStatus | QuoteWorkflowStatus[]
  ): string | void {
    const statusesT = Array.isArray(statuses) ? statuses : [statuses];
    return findLast(
      sortBy(quote.statusHistory, 'timestamp'),
      ({ workflowStatus }: QuoteStatusHistory) =>
        includes(statusesT, workflowStatus)
    )?.timestamp;
  }
}
